module.exports = __webpack_public_path__ + "img/GG.07a103d7.png";